
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { UnitInputValue } from "@/types/unit";
import UnitInput from "./UnitInput/UnitInput.vue";
import Icon from "@/components/UI/Icon.vue";

type BorderRadiusSide =
  | "all"
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight";

type BorderRadiusEditMode = "all" | "custom" | undefined;

type BorderRadiusInputValue = {
  all?: UnitInputValue;
  topLeft?: UnitInputValue;
  topRight?: UnitInputValue;
  bottomLeft?: UnitInputValue;
  bottomRight?: UnitInputValue;
  editMode?: BorderRadiusEditMode;
};

const RADIUS_SIDES = [
  "all",
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight"
] as const;

@Component({
  components: { UnitInput, Icon }
})
export default class BorderRadius extends Vue {
  @Prop({
    default: null
  })
  value!: BorderRadiusInputValue | null;

  mode: BorderRadiusEditMode = "all";

  edit(unitInputValue: UnitInputValue, key: BorderRadiusSide) {
    if (key === "all") {
      this.applyUnitInputValueToAllAndEmit(unitInputValue);
    } else {
      const newValue: BorderRadiusInputValue = {
        ...this.value,
        [key]: unitInputValue
      };
      newValue.editMode = "custom";

      const thereIsASetField = Object.values(newValue).some(
        value => value && value !== "custom"
      );

      if (!thereIsASetField) {
        this.$emit("input", null);
        return;
      }

      this.$emit("input", newValue);
    }
  }

  applyUnitInputValueToAllAndEmit(unitInputValue: UnitInputValue) {
    if (unitInputValue === null) {
      this.$emit("input", null);
      return;
    }

    const newValue: BorderRadiusInputValue = {};
    RADIUS_SIDES.forEach(key => {
      newValue[key] = unitInputValue;
    });
    newValue.editMode = "all";
    this.$emit("input", newValue);
  }

  get editMode() {
    return this.value?.editMode || this.mode;
  }

  set editMode(editModeInputValue: BorderRadiusEditMode) {
    this.mode = editModeInputValue;
  }
}
